var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-items" },
    _vm._l(_vm.tabs, function(tab, index) {
      return _c(
        "router-link",
        {
          key: index,
          staticClass: "item",
          attrs: { to: tab.linkto },
          nativeOn: {
            click: function($event) {
              return _vm.closeSidebar.apply(null, arguments)
            }
          }
        },
        [
          _c("i", { staticClass: "icon", class: tab.icon }),
          _vm._v("\n\t\t" + _vm._s(tab.title) + "\n\t")
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-117f5fe7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-117f5fe7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Sidebar.vue
// module id = VLFo
// module chunks = 1